export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11932.d58b45a3.jpg";